let baseUrl = "" ;
console.log(process.env.NODE_ENV);
switch (process.env.NODE_ENV) {
  case "development":
    baseUrl = "http://192.168.1.218:10089/"; //这里是本地的请求url
    break;
  case "test": // 注意这里的名字要和步骤二中设置的环境名字对应起来
    baseUrl = "http://192.168.1.218:10089/"; //这里是测试环境中的url
    break;
  case "production":
    baseUrl = "https://omsdata.jiabs.com/"; //生产环境url
    break;
}
export default baseUrl;
